import React, { useState } from "react";
import AdminAPI from "../../services/adminApi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function AdminLogin() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    email: "",
    password: ""
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const res = await AdminAPI.post("/login", form);

      localStorage.setItem(
        "admin_token",
        res.data.token
      );

      localStorage.setItem(
        "admin_data",
        JSON.stringify(res.data.admin)
      );

      toast.success("Admin login successful");

      navigate("/admin/dashboard");

    } catch (err) {
      toast.error(
        err.response?.data?.message ||
        "Login failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{
        background:
          "linear-gradient(135deg, #1b5e20, #4caf50)"
      }}
    >
      <div
        className="card shadow-lg border-0"
        style={{
          width: "420px",
          borderRadius: "20px"
        }}
      >
        <div className="card-body p-5">
          <h2 className="text-center mb-4 text-success fw-bold">
            Admin Login
          </h2>

          <form onSubmit={handleSubmit}>
            <input
              type="email"
              name="email"
              className="form-control mb-3"
              placeholder="Admin Email"
              value={form.email}
              onChange={handleChange}
              required
            />

            <input
              type="password"
              name="password"
              className="form-control mb-4"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              required
            />

            <button
              className="btn btn-success w-100"
              disabled={loading}
            >
              {loading
                ? "Logging in..."
                : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;